import { useState } from 'react';
import Box from '@mui/material/Box';
import Person from '@mui/icons-material/PersonOutline';
import { Form, Formik } from "formik";
import RecoverPasswordValidationSchema from "./RecoverPasswordValidationSchema";
import RecoverPasswordInitialValues from "./RecoverPasswordInitialValues";
import SubmitButton from "../buttons/SubmitButton";
import CancelButton from '../buttons/CancelButton';
import SuccessToast from "../toasts/SuccessToast";
import { sendRecoveryPassMail } from "../../../../../api/accountApi";
import OutlinedTextField from '../../../../../components/formFields/OutlinedTextField';
import ErrorToast from '../toasts/ErrorToast';

export default function RecoverPasswordForm() {

  const [showSuccess, setShowSuccess] = useState(false)
  const [showError, setShowError] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)

  const handleSubmit = (value: any, action: any) => {
    setIsDisabled(true);
    sendRecoveryPassMail(value.email)
    .then(() => {
      setShowSuccess(true);
      setIsDisabled(false);
    })
    .catch(() => {
      setShowError(true);
    })
    .finally(() => {
      action.resetForm();
    })
  }

  return (
    <Formik
        initialValues={RecoverPasswordInitialValues}
        onSubmit={handleSubmit}
        validationSchema={RecoverPasswordValidationSchema}
        isInitialValid={false}
    >
      {({ isSubmitting, isValid }: any) => (
      <Form id="register">
        <Box sx={{margin: '0 5%'}}>
          <Box sx={{ display: 'flex' }}>
          <Person sx={{ m: 2, color: '#008F39' }} />
          <OutlinedTextField
            label="E-mail"
            name="email"
            requiredField
            fullWidth={true}
            />
          </Box>
          {showSuccess && <SuccessToast></SuccessToast>}
          {showError && <ErrorToast></ErrorToast>}
          <Box className="centered" sx={{padding: '27px 0'}}>
            <CancelButton></CancelButton>
            <SubmitButton isValid={isValid && !isDisabled} isSubmitting={isSubmitting}></SubmitButton>
          </Box>
        </Box>
      </Form>
      )}
    </Formik>
  );
}